import * as React from "react";

import { style } from "../shapes-utils";
import { CollorButton } from "./styles";
import { FormattedMessage } from "react-intl";

export default function ColorButton({ currentColor, setColor, id }) {
  const getButtonColor = (number) => {
    switch (number) {
      case 1: {
        return {
          color2: "#0a0a0b",
          color1: "#F4F4F4",
          label: <FormattedMessage id={"ai_creator.color.black_white"} />,
        };
      }
      case 2: {
        return {
          color2: "#0a0a0b",
          color1: "#f1a12e",
          label: <FormattedMessage id={"ai_creator.color.black_orange"} />,
        };
      }
      default:
      case 3:
        return {
          color2: "#F4F4F4",
          color1: "#2d6fba",
          label: <FormattedMessage id={"ai_creator.color.white_blue"} />,
        };
      case 4:
        return {
          color2: "#F4F4F4",
          color1: "#A22120",
          label: <FormattedMessage id={"ai_creator.color.white_red"} />,
        };
      case 5: {
        return {
          color2: "#F4F4F4",
          color1: "#16a34a",
          label: <FormattedMessage id={"ai_creator.color.white_green"} />,
        };
      }
    }
  };

  const gradientId = `paint1_linear_${id}`;

  return (
    <CollorButton
      role="button"
      onClick={() => setColor(id)}
      active={currentColor === id}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        fill="none"
        viewBox="0 0 35 35"
      >
        <circle
          style={style}
          cx="17"
          cy="17"
          r="16"
          stroke={"#DDE5E9"}
          strokeWidth="2"
          transform="matrix(1 0 0 -1 .23 34.829)"
        ></circle>
        <circle
          cx="12"
          cy="12"
          r="12"
          fill={`url(#${gradientId})`}
          transform="matrix(1 0 0 -1 5.23 29.829)"
        ></circle>
        <defs>
          <linearGradient
            id={gradientId}
            x1="12"
            x2="12"
            y1="0"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.5" stopColor={getButtonColor(id).color1}></stop>
            <stop offset="0.5" stopColor={getButtonColor(id).color2}></stop>
          </linearGradient>
        </defs>
      </svg>

      <span>{getButtonColor(id).label}</span>
    </CollorButton>
  );
}
